<template>
  <span>{{ formattedValue }}</span>
</template>

<script>
export default {
  name: "AnimatedNumberComponent",
  props: {
    value: {
      type: Number,
      required: true,
      default: 0
    },
    duration: {
      type: Number,
      default: 1000
    },
    formatOptions: {
      type: Object,
      default: () => ({ minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  },
  data() {
    return {
      displayValue: 0,
      startTime: null,
      startValue: 0,
      animationFrameId: null
    };
  },
  computed: {
    formattedValue() {
      return Intl.NumberFormat('en-GB', this.formatOptions).format(this.displayValue);
    }
  },
  watch: {
    value(newVal) {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      this.displayValue = 0;
      this.animate(newVal);
    }
  },
  mounted() {
    this.displayValue = 0;
    this.animate(this.value);
  },
  beforeDestroy() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
  },
  methods: {
    animate(targetValue) {
      if (this.startValue === targetValue && this.displayValue === targetValue) return;
      
      this.startValue = 0;
      this.startTime = performance.now();
      
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      
      const step = (currentTime) => {
        const elapsedTime = currentTime - this.startTime;
        const progress = Math.min(elapsedTime / this.duration, 1);
        
        // Easing (easeOutQuad)
        const easeProgress = progress * (2 - progress);
        
        this.displayValue = this.startValue + (targetValue - this.startValue) * easeProgress;
        
        if (progress < 1) {
          this.animationFrameId = requestAnimationFrame(step);
        } else {
          this.displayValue = targetValue;
          this.animationFrameId = null;
        }
      };
      
      this.animationFrameId = requestAnimationFrame(step);
    }
  }
};
</script>
